import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "flex-node-col"
}
const _hoisted_2 = { style: {"flex":"0 0 auto","display":"flex","flex-direction":"row","justify-content":"center"} }
const _hoisted_3 = { style: {"margin-left":"auto"} }
const _hoisted_4 = ["src"]
const _hoisted_5 = ["src"]
const _hoisted_6 = ["src"]
const _hoisted_7 = ["src"]
const _hoisted_8 = ["src"]
const _hoisted_9 = ["src"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_k_label = _resolveComponent("k-label")!
  const _component_checkbox = _resolveComponent("checkbox")!
  const _component_tree_list = _resolveComponent("tree-list")!

  return (_ctx.bomData != null)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("p", null, _toDisplayString(_ctx.localize('Material')) + ": " + _toDisplayString(_ctx.materialDescription), 1),
          _createElementVNode("p", _hoisted_3, [
            _createVNode(_component_checkbox, {
              id: "chkFilterEnabled",
              modelValue: _ctx.data.filterEnabled,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.data.filterEnabled) = $event))
            }, {
              default: _withCtx(() => [
                _createVNode(_component_k_label, { for: "chkFilterEnabled" }, {
                  default: _withCtx(() => [
                    _createElementVNode("b", null, _toDisplayString(_ctx.localize('Filter')), 1)
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }, 8, ["modelValue"])
          ])
        ]),
        _createVNode(_component_tree_list, {
          class: "flex-item-scroll",
          "expand-field": _ctx.data.expandField,
          "sub-items-field": _ctx.data.subItemsField,
          "data-items": _ctx.processedData,
          columns: _ctx.columnDef,
          filter: _ctx.data.filter,
          filterable: _ctx.data.filterEnabled,
          sort: _ctx.data.sort,
          sortable: true,
          onDatastatechange: _ctx.handleDataStateChange,
          onExpandchange: _ctx.onExpandChange
        }, {
          renderRightJustified: _withCtx(({props}) => [
            _createElementVNode("td", {
              class: _normalizeClass(props.className),
              style: {"text-align":"right"}
            }, _toDisplayString(props.dataItem[props.field]), 3)
          ]),
          renderQty: _withCtx(({props}) => [
            _createElementVNode("td", {
              class: _normalizeClass(props.className),
              style: {"text-align":"right","white-space":"nowrap"}
            }, _toDisplayString(_ctx.formatQty(props.dataItem)), 3)
          ]),
          renderPrice: _withCtx(({props}) => [
            _createElementVNode("td", {
              class: _normalizeClass(props.className),
              style: {"text-align":"right"}
            }, _toDisplayString(_ctx.formatPrice(props.dataItem[props.field])), 3)
          ]),
          renderIcons: _withCtx(({props}) => [
            _createElementVNode("td", {
              class: _normalizeClass(props.className),
              style: {"vertical-align":"middle","text-align":"center"}
            }, [
              ((props.dataItem['warning'] ?? '') != '')
                ? (_openBlock(), _createElementBlock("img", {
                    key: 0,
                    src: _ctx.iconPathWarning
                  }, null, 8, _hoisted_4))
                : _createCommentVNode("", true),
              (props.dataItem['hasProductionBom'])
                ? (_openBlock(), _createElementBlock("img", {
                    key: 1,
                    src: _ctx.iconPathProduction,
                    class: "withIcon"
                  }, null, 8, _hoisted_5))
                : _createCommentVNode("", true),
              (props.dataItem['hasSeveralAlternativeBoms'])
                ? (_openBlock(), _createElementBlock("img", {
                    key: 2,
                    src: _ctx.iconPathAlternative,
                    class: "withIcon"
                  }, null, 8, _hoisted_6))
                : _createCommentVNode("", true),
              (props.dataItem['hasReplacement'])
                ? (_openBlock(), _createElementBlock("img", {
                    key: 3,
                    src: _ctx.iconPathReplaced,
                    class: "withIcon"
                  }, null, 8, _hoisted_7))
                : _createCommentVNode("", true),
              (props.dataItem['hasMaintenanceBom'])
                ? (_openBlock(), _createElementBlock("img", {
                    key: 4,
                    src: _ctx.iconPathMaintenance,
                    class: "withIcon"
                  }, null, 8, _hoisted_8))
                : _createCommentVNode("", true),
              (props.dataItem['hasBoughtWithBom'])
                ? (_openBlock(), _createElementBlock("img", {
                    key: 5,
                    src: _ctx.iconPathBoughtTogether,
                    class: "withIcon"
                  }, null, 8, _hoisted_9))
                : _createCommentVNode("", true)
            ], 2)
          ]),
          _: 1
        }, 8, ["expand-field", "sub-items-field", "data-items", "columns", "filter", "filterable", "sort", "onDatastatechange", "onExpandchange"])
      ]))
    : _createCommentVNode("", true)
}